import { BoardType } from '../../../api/ApiTypes';
import { ClientManager, Communicator } from '../../../concepts/objects';
import { AppEventStreams, AppEvents } from '../../AppEvents';
import { ActiveObject, resolve } from '../../Container';
import { ProfileModel } from '../../ProfileModel';
import { BoardInfo } from '../BoardInfo';
import { EditorSession } from '../EditorSession';
import { MyRoleInfo } from '../MyRoleInfo';
import { WidgetManager } from '../workspace/widgets/WidgetManager';
import { ParticipantManager } from './ParticipantManager';
import { ParticipantStripInfo } from './ParticipantStripInfo';
import { ParticipantStripWidget } from './ParticipantStripWidget';

export class ParticipantMechanics extends ActiveObject {

    @resolve(AppEvents) private appEvents!: AppEvents;
    @resolve(ClientManager) private clients!: ClientManager;
    @resolve(Communicator) private comms!: Communicator;
    @resolve(ProfileModel) private me!: ProfileModel;
    @resolve(ParticipantManager) private participants!: ParticipantManager;
    @resolve(EditorSession) private session!: EditorSession;
    @resolve(WidgetManager) private widgets!: WidgetManager;

    public start() {
        this.realizeParticipantStrip();
        this.handleTracking();
        this.burden(
            this.appEvents.on('user:patch', this.handleUserPatch),
            this.comms.recv('arrive', this.onArrive),
            this.comms.recv('kick', this.onKick),
            this.session.observe(MyRoleInfo, this.handleTracking),
            this.session.observe(ParticipantStripInfo, this.realizeParticipantStrip),
        );
    }

    private onArrive = (sender: any) => {
        const ptpt = this.participants.get(sender.userId);
        if (ptpt) ptpt.update({ lastSeenAt: new Date() });
    };

    private onKick = (_sender: any, { target }: any) => {
        const { canParticipate } = this.session.get(MyRoleInfo);
        if (target === this.me.id || (target === 'viewers' && !canParticipate)) {
            window.location.reload();
        }
    };

    private realizeParticipantStrip = () => {
        const { widgets } = this;

        widgets.delete('participants');

        if (!this.session.get(ParticipantStripInfo).enabled) return;
        if (this.session.get(BoardInfo).type !== BoardType.standard) return;

        const container = widgets.createContainer({
            name: 'participants',
            position: ['docked', 'topRight', 'inline'],
            weight: 100,
            style: 'none',
        });

        container.add(widgets.createInline({
            ui: ParticipantStripWidget,
        }));

        widgets.add(container);
    };

    private handleTracking = () => {
        // Track if we can participate, otherwise don't track
        const { canParticipate } = this.session.get(MyRoleInfo);
        this.clients.self.patch({ track: !!canParticipate });
    };

    private handleUserPatch = ({ userId }: AppEventStreams['user:patch']) => {
        this.participants.refreshParticipant(userId);
    };
}
